/**
 * Brojano zakljucavanje skrola.
 *
 * Vise komponenti moze istovremeno da trazi zakljucan skrol (preloader dok
 * traje uvod, mobilni meni, modal za pakete). Kad bi svaka sama pisala
 * `document.body.style.overflow`, ona koja se prva otkljuca odblokirala bi
 * stranicu iako je druga jos drzi. Zato se broje zahtevi i stvarni stil se
 * vraca tek kad poslednji otpusti.
 */

let locks = 0;
let previousOverflow = '';
let previousPaddingRight = '';

/** Sirina sistemskog skrolbara — bez kompenzacije sadrzaj poskoci pri zakljucavanju. */
function scrollbarWidth() {
  return window.innerWidth - document.documentElement.clientWidth;
}

/**
 * Zakljucava skrol i vraca funkciju za otkljucavanje.
 * Otkljucavanje je idempotentno — visestruki poziv broji samo jednom.
 */
export function lockScroll() {
  if (typeof document === 'undefined') return () => {};

  if (locks === 0) {
    const { body } = document;
    previousOverflow = body.style.overflow;
    previousPaddingRight = body.style.paddingRight;

    const gap = scrollbarWidth();
    if (gap > 0) {
      const current = parseFloat(getComputedStyle(body).paddingRight) || 0;
      body.style.paddingRight = `${current + gap}px`;
    }
    body.style.overflow = 'hidden';
  }
  locks += 1;

  let released = false;
  return function unlock() {
    if (released) return;
    released = true;
    locks = Math.max(0, locks - 1);
    if (locks === 0) {
      document.body.style.overflow = previousOverflow;
      document.body.style.paddingRight = previousPaddingRight;
    }
  };
}
